import { render, staticRenderFns } from "./vinSearchGoodsForUnion.vue?vue&type=template&id=754980c2&scoped=true&"
import script from "./vinSearchGoodsForUnion.vue?vue&type=script&lang=js&"
export * from "./vinSearchGoodsForUnion.vue?vue&type=script&lang=js&"
import style0 from "./vinSearchGoodsForUnion.vue?vue&type=style&index=0&id=754980c2&lang=less&scoped=true&"
import style1 from "./vinSearchGoodsForUnion.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754980c2",
  null
  
)

component.options.__file = "vinSearchGoodsForUnion.vue"
export default component.exports